// Test IDs for the pooja samagri store, cart, checkout & astrology flows.

export const NAV = {
  logo: 'nav-logo',
  homeLink: 'nav-home-link',
  predictionsLink: 'nav-predictions-link',
  storeLink: 'nav-store-link',
  languageSwitcher: 'nav-language-switcher',
  cartButton: 'nav-cart-button',
  loginLink: 'nav-login-link',
  registerLink: 'nav-register-link',
  logoutButton: 'nav-logout-button',
  themeToggle: 'nav-theme-toggle',
};

export const HOMEPAGE = {
  heroCta: 'home-hero-cta',
  heroSecondaryCta: 'home-hero-secondary-cta',
  predictionsCta: 'home-predictions-cta',
  storeCta: 'home-store-cta',
};

export const PREDICTIONS = {
  tabDaily: 'predictions-tab-daily',
  tabKundli: 'predictions-tab-kundli',
  tabMini: 'predictions-tab-mini',
  signSelector: (sign) => `predictions-sign-${sign}`,
  dailyGenerateBtn: 'predictions-daily-generate-btn',
  dailyResult: 'predictions-daily-result',
  kundliName: 'predictions-kundli-name',
  kundliDob: 'predictions-kundli-dob',
  kundliTob: 'predictions-kundli-tob',
  kundliPob: 'predictions-kundli-pob',
  kundliGenerateBtn: 'predictions-kundli-generate-btn',
  kundliResult: 'predictions-kundli-result',
  miniTopic: (topic) => `predictions-mini-topic-${topic}`,
  miniGenerateBtn: 'predictions-mini-generate-btn',
  miniResult: 'predictions-mini-result',
};

export const STORE = {
  grid: 'store-grid',
  productCard: (sku) => `store-product-${sku}`,
  addToCartBtn: (sku) => `store-add-to-cart-${sku}`,
};

export const CART = {
  drawer: 'cart-drawer',
  item: (sku) => `cart-item-${sku}`,
  qtyInc: (sku) => `cart-qty-inc-${sku}`,
  qtyDec: (sku) => `cart-qty-dec-${sku}`,
  removeBtn: (sku) => `cart-remove-${sku}`,
  total: 'cart-total',
  checkoutBtn: 'cart-checkout-btn',
  empty: 'cart-empty',
};

export const PAYMENT = {
  successStatus: 'payment-success-status',
  cancelStatus: 'payment-cancel-status',
  homeLink: 'payment-home-link',
};
